export const secondsInTimeFormat = duration => {
	const hours = Math.floor(duration / 3600);
	const minutes = Math.floor((duration % 3600) / 60);
	const seconds = Math.round(duration % 60);
	return [
		hours ? (hours > 9 ? hours : '0' + hours) : '00',
		minutes ? (minutes > 9 ? minutes : '0' + minutes) : '00',
		seconds ? (seconds > 9 ? seconds : '0' + seconds) : '00'
	].join(':');
};
